<template>
  <div class="mt-6 mb-6  flex flex-col  items-center justify-center w-full   ">
    <div class="  w-full flex flex-row  relative ">
      <div class="  w-full flex flex-col   ">

        <div class="  w-full    flex flex-row">

          <div class="   w-full  ">
            <div class="   w-full  ">

              <div class="flex flex-wrap w-full  ">
                <div v-for="(section,indexSection) in dashboard?.sections" :id="indexSection" :key="section?._id"
                  class="md:p-2 lg:p-2 xl:p-1 group  flex flex-wrap   " :class="getSectionClass(section)">

                  <ChartSectionComponent class=" h-auto" :id="section._id" :section="section" :tab="currentTab"
                    :refresh="onRefresh" :config="item" :class="section.class_chart" :reports="reports" freezer="false"
                    @editProperties="OnEditDiagram" @updateValue="OnUpdateValue" />
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>
<script>
  import labels from "@/assets/lg/component_label.json"
  import ChartSectionComponent from "@/components/ChartSectionComponent.vue"
  import service from "@/services/FullService.vue"
  import { mapGetters } from "vuex";
  export default {
    name: 'ContentChartInForm',
    components: {
      ChartSectionComponent
    },
    props: {
      source: Object,
      value: Object,
      config: Object
    },
    computed: {
      ...mapGetters({ user: "StateUser" }),
      isLoggedIn: function () {
        return this.$store.getters.isAuthenticated;
      },
    },
    data() {
      return {
        refresh: String,
        reports: {},
        currentTab: 0,
        dashboard:        {    },
        output: {},

        labels: labels,
        lg: 'FR',

      }
    },
    watch: {
      'refresh': async function () {
 
        await this.loadDashboard();

      },
      value: function () {

        //   this.output = val;
      }
    },
    async mounted() {
      await this.loadDashboard();

    },
    methods: {
      onRefresh() {
        this.refresh = Math.random().toString(36).substring(7);
  
      },
      async getRemoteData(id) {
        let filter = {}
        if (id == undefined) {
          return {
            total: 0,
            records: []
          }
        }

        let records = await service.generateReport("data-sources/" + id + '/charts', this.user?.token, Object.assign({}, { limit: 10, offset: 0 }, filter))
        return records
      },
      onRefeshChart: async function (item) {
     
        let source_id = item?.config?.source?.id
        // let source_id = "663522bde3498f69e81035bd"

        let response = await this.getRemoteData(source_id, item)
  
        this.reports[item.id] = response
      },


      loadDashboard: async function () {
        if (this.user == undefined) return;
        let id = this.config?.dashboard_id;

 


        if (id == undefined) return
        let config = await service.getDataId("dashboards", id, this.user?.token, {})
        //  console.log(tpl)
        //  let config = { records: [tpl], total: 1 };
        if ((config != undefined)) {
          //  console.log(config)
          this.dashboard = config?.tabs[this.currentTab]
          this.tabs = config?.tabs
          //  this.listRight()
          return;
        }
        this.dashboard = { tabs: [] }
        // this.listRight()
      },

      getSectionClass: function (item) {
        if (item == undefined) return ''
        //   return 'grid grid-cols-' + item.cols.length + ' gap-4 mb-6'
        return ' ' + item.class
      },
      getData() {
        return "";
        //   return this.labels['BUTTON_EDIT'][this.lg];
      },


    }
  }
</script>